// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"f0956f65","1764":"f01e9c83","3540":"0b887419","4450":"a95dd117","5735":"c0a00510","6687":"c0a00510","9826":"4890d95a"}[chunkId] + ".chunk.css";
};